import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import isEmpty from 'lodash/isEmpty';
import useStyles from './style';
import Typography from '../../../components/atoms/Typography';
import Grid from '../../../components/molecules/Grid';
import { COMPONENT_NAME } from './locators';
import QuoteIcon from '../../../../styles/svgIcons/QuoteIcon';
import clsx from 'clsx';
import { getUId } from '../../../../utils/utility';

const Quote = (props) => {
  const { fields, from } = props
  const classes = useStyles();
  if (isEmpty(fields)) {
    return null;
  }
  const uid = getUId(props)
  const {
    title,
    description,
    authorName,
    authorDesignation,
  } = fields;

  let designation = authorDesignation.value;
  if (designation && !designation.startsWith('—')) {
    designation = `— ${designation}`
  }

  return (
    <div className="quoteComponentWrapper">
      <Grid className={clsx({
        [classes.root]: from !== 'QuotesCarousel',
        [classes.carouselRoot]: from === 'QuotesCarousel',
      })} data-locator={COMPONENT_NAME} uid={uid}>
        <Grid
          container
          spacing={0}
        >
          <Grid item xs={12} lg={from !== 'QuotesCarousel' ? 10 : 12}>
            {
              title && title.value &&
              <Typography variant="h4" component="h2" className={classes.title}>
                <Text field={title} />
              </Typography>
            }
            {
              description && description.value &&
              <Typography variant="h5" component="p" className={classes.description}>
                <i className={classes.quoteIcon}>{QuoteIcon}</i>
                <Text field={description} />
              </Typography>
            }
            {
              authorName && authorName.value &&
              <Typography variant="body1Bold" component="p" className={`${classes.author} authorColor`}>
                <Text field={authorName} />
              </Typography>
            }
            {
              designation &&
              <Typography variant="body4" component="p" className={classes.authorDesignation}>
                <Text field={{ value: designation }} />
              </Typography>
            }
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default Quote;
